import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.scss'],
})
export class CommonTableComponent {
  @Input() tableHeaders: any[] = [];
  @Input() tableData: any[] = [];
  @Input() customClass: any[] = [];
  @Input() sortBy: string = '';
  @Input() sortOrder: 'asc' | 'desc' = 'asc';
  @Output() sortChange = new EventEmitter<string>();

  onHeaderClick(header: any): void {
    if (header.isSortable) {
      this.sortChange.emit(header.field);
    }
  }

  isSortable(header: any): boolean {
    return header.isSortable === true;
  }

  isSorted(header: any): boolean {
    return this.sortBy === header.field;
  }

  getSortIcon(header: any): string {
    if (!this.isSorted(header)) {
      return 'arrow_upward';
    }
    return this.sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward';
  }
}
